import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.updateDeseaseSetting.loading;
export const selectErrorMessage = (state: RootState) =>
  state.updateDeseaseSetting.error;
export const updateDeseaseSettingResponse = (state: RootState) =>
  state.updateDeseaseSetting.updateDeseaseSettingResponse;
